<template>
  <div>
    <el-row class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="16" :md="16">
        <el-input v-model="filtroText" placeholder="Filtrar..." @keyup.native.enter="loadingItens"></el-input>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <el-button type="primary" @click="openDialog()">NOVO ITEM</el-button>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th>Item da cotação</th>
            <th class="hidden-mobile u-text-right">Valor unitário</th>
            <th class="hidden-mobile u-text-right">Valor total</th>
            <th style="width: 150px;" class="u-text-center">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in itensFiltrados" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>
              <span v-if="item.cotacao_item && item.cotacao_item.produto">
                {{ item.cotacao_item.produto.nome }} ({{ item.cotacao_item.quantidade }})
              </span>
              <span v-else>#{{ item.cotacao_item_id }}</span>
            </td>
            <td class="hidden-mobile u-text-right">{{ formatMoney(item.valor_unitario) }}</td>
            <td class="hidden-mobile u-text-right">{{ formatMoney(item.valor_total) }}</td>
            <td class="u-text-center acao">
              <el-button @click="openDialog(item)" title="Editar" type="info" icon="el-icon-edit" size="mini" plain></el-button>
              <el-button @click="deleteItem(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!statusList" class="u-text-center u-mt-25">
        <img src="/public/img/loading-bar.gif" />
      </div>
    </div>

    <el-dialog append-to-body :title="dialogEdit ? 'Editar Item' : 'Novo Item'" :visible.sync="dialogVisible" width="70%" top="5vh">
      <el-form :model="form" ref="form" label-position="top">
        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Item da cotação" prop="cotacao_item_id" :rules="[$requiredChange]" key="cotacao_item_id">
              <el-select v-model="form.cotacao_item_id" filterable clearable placeholder="Selecione">
                <el-option v-for="opt in cotacaoItens" :key="opt.id" :label="cotacaoItemLabel(opt)" :value="opt.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Valor unitário" prop="valor_unitario" :rules="[$requiredBlur]" key="valor_unitario">
              <el-input v-model="form.valor_unitario"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Valor total" prop="valor_total" :rules="[$requiredBlur]" key="valor_total">
              <el-input v-model="form.valor_total"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">CANCELAR</el-button>
        <el-button type="primary" @click="saveItem">SALVAR</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtroText: '',
    itens: [],
    dialogVisible: false,
    dialogEdit: false,
    proposta: null,
    cotacaoItens: [],
    form: {
      id: '',
      proposta_id: '',
      cotacao_item_id: '',
      valor_unitario: '',
      valor_total: ''
    }
  }),
  mounted () {
    this.bootstrap()
  },
  computed: {
    propostaId () {
      return this.$route.params.proposta_id
    },
    itensFiltrados () {
      if (!this.filtroText) return this.itens
      const q = String(this.filtroText).toLowerCase()
      return this.itens.filter(i => {
        const label = (i.cotacao_item && i.cotacao_item.produto) ? i.cotacao_item.produto.nome : ''
        return String(label).toLowerCase().includes(q)
      })
    }
  },
  methods: {
    async bootstrap () {
      await this.loadProposta()
      await this.loadCotacaoItens()
      await this.loadingItens()
    },
    loadProposta () {
      return this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/financeiro/proposta/getById/` + this.propostaId, this.$store.getters.getHeaderAuth)
        .then(resp => { this.proposta = resp.data })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    loadCotacaoItens () {
      if (!this.proposta || !this.proposta.cotacao_id) return Promise.resolve()
      return this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/financeiro/cotacao/getById/` + this.proposta.cotacao_id, this.$store.getters.getHeaderAuth)
        .then(resp => { this.cotacaoItens = (resp.data && resp.data.itens) ? resp.data.itens : [] })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    loadingItens () {
      this.statusList = false
      this.itens = []
      const filtro = { proposta_id: this.propostaId }
      return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/proposta-item/getAllPaginate?page=1`, filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.itens = response.data.data
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    cotacaoItemLabel (opt) {
      const nome = (opt.produto && opt.produto.nome) ? opt.produto.nome : ('#' + opt.produto_id)
      return `${nome} - qtd: ${opt.quantidade}`
    },
    openDialog (item = null) {
      this.dialogVisible = true
      this.dialogEdit = !!item
      if (item) {
        this.form = {
          id: item.id,
          proposta_id: item.proposta_id,
          cotacao_item_id: item.cotacao_item_id,
          valor_unitario: item.valor_unitario,
          valor_total: item.valor_total
        }
      } else {
        this.form = { id: '', proposta_id: this.propostaId, cotacao_item_id: '', valor_unitario: '', valor_total: '' }
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    saveItem () {
      this.$refs.form.validate((valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        const payload = Object.assign({}, this.form, { proposta_id: this.propostaId })
        if (this.dialogEdit) {
          this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/proposta-item/update/` + payload.id, payload, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.dialogVisible = false
            this.loadingItens()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        } else {
          this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/proposta-item/store`, payload, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.dialogVisible = false
            this.loadingItens()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }
      })
    },
    deleteItem (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir este item?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/financeiro/proposta-item/delete/` + id, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.loadingItens()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    formatMoney (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>

